module.exports = __webpack_public_path__ + "static/img/home_header_logo_duihaoli.89e74216.png";